import { MapPin2 } from "@styled-icons/remix-fill/MapPin2";
import { CloseCircle } from "@styled-icons/remix-line/CloseCircle";
import { Button, Col, Dropdown, Input, Row, Typography } from "antd";
import styled, { css } from "styled-components";

import { TokenProps } from "./types";

import { BRAND_BOOK_COLORS } from "~/Constant/Theme/configs/equipmentshare";

export const ColFacet = styled(Col).attrs({
  xs: 24,
  sm: 24,
  md: 12,
  lg: 12,
  xl: 12,
})``;

export const RowJobListing = styled(Row).attrs<TokenProps & { $skeleton?: boolean }>({
  gutter: 0,
})`
  border: 1px solid ${(props) => props.$token.colorBorder};
  margin-bottom: 1rem;
  border-radius: ${(props) => props.$token.borderRadius}px;

  ${(props) =>
    props.$skeleton
      ? ""
      : css`
          &:hover {
            background-color: ${props.$token.colorPrimaryBg};
            border-color: ${props.$token.colorPrimaryBorderHover};
          }
        `}
`;

export const ColJobBase = styled(Col)`
  align-items: center;
  display: flex;
  padding: 0.75rem 1.5rem;
`;

export const ColJobTitle = styled(ColJobBase).attrs<TokenProps>({
  xs: 24,
  sm: 24,
  md: 24,
  lg: 10,
  xl: 10,
})`
  b {
    ${(props) => (props.$token?.colorPrimary ? `color: ${props.$token?.colorPrimary};` : "")};
  }
  padding: 0.75rem 3.125rem;

  @media (max-width: 992px) {
    padding: 1.25rem 1.75rem;
  }
`;

export const ColJobDepartment = styled(ColJobBase).attrs({
  xs: 0,
  sm: 0,
  md: 0,
  lg: 7,
  xl: 7,
})`
  @media (max-width: 992px) {
    display: none;
  }
`;

export const ColJobLocation = styled(ColJobBase).attrs({
  xs: 0,
  sm: 0,
  md: 0,
  lg: 7,
  xl: 7,
})`
  @media (max-width: 992px) {
    display: none;
  }
`;

export const ColTitle = styled(Typography.Title).attrs({
  level: 4,
})`
  margin: 0;
  color: black !important;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 800 !important;
  line-height: 24px !important;
  letter-spacing: 0.6px !important;
  text-transform: capitalize !important;
`;

export const PrimaryControlsRoot = styled(Row)<TokenProps & { $isInstantSearch?: boolean }>`
  column-gap: ${({ $isInstantSearch }) => ($isInstantSearch ? "24px" : "8px")};
  row-gap: 16px;
  #cell-one,
  #cell-two {
    flex: 1;
  }
  #cell-one .ant-input-affix-wrapper {
    border-radius: 5px 0px 0px 5px;
    flex: 1;
  }
  #cell-one .ant-btn {
    border-left-color: transparent !important;
    border-radius: 0px 5px 5px 0px;
    width: 8.375rem;
  }
  #cell-one .ant-dropdown {
    min-width: 150px;
  }
  #cell-two > div {
    gap: 11px 8px;
  }
  @media screen and (max-width: 992px) {
    flex-direction: column;
    row-gap: 11px;
    #cell-one > div {
      flex-direction: column;
      row-gap: 11px;
    }
    #cell-one .ant-input-affix-wrapper {
      border-radius: 5px;
      padding: 0px 11px;
    }
    #job-location-filter .ant-btn {
      border-left-color: ${BRAND_BOOK_COLORS.GRAY_DARK} !important;
      border-radius: 5px;
      width: 100%;
    }
    #job-search-bar {
      height: 2.5rem;
    }
  }
`;

export const PrimaryControlsCol = styled(Col).attrs({
  xs: 24,
  lg: 12,
})``;

export const SearchBarInput = styled(Input)`
  font-size: 15px !important;
`;

export const JobTypeFilterSelect = styled(Dropdown)<TokenProps>`
  &.ant-btn {
    background-color: #f6f6f6 !important;
    border: 1px solid ${BRAND_BOOK_COLORS.GRAY_DARK} !important;
    color: ${(props) => `${props.$token?.colorTextSecondary}!important`};
    cursor: pointer;
    font-size: 15px;
    height: 3.625rem;
    text-transform: capitalize;
    width: 100%;
  }

  @media screen and (max-width: 992px) {
    &.ant-btn {
      background-color: ${BRAND_BOOK_COLORS.WHITE} !important;
      justify-content: space-between !important;
      height: 2.5rem;
    }
  }
`;

export const JobTypeFilterSelectButton = styled(Button)`
  column-gap: 4px;
  padding: 17px 12px;
  @media screen and (max-width: 992px) {
    &.ant-btn {
      padding-right: 10px;
    }
  }
`;

export const JobTypeFilterOptions = styled("div")`
  background: ${BRAND_BOOK_COLORS.WHITE};
  border-radius: 8px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  margin-top: 2px;
  min-width: 160px;
  padding: 4px;
  .ant-checkbox-group,
  .ant-checkbox-group > .ant-flex,
  .ant-checkbox-wrapper {
    width: 100%;
  }
  .ant-checkbox-group > .ant-flex {
    gap: 2px;
  }
  .ant-checkbox-wrapper {
    width: 100%;
    padding: 4px 12px;
    border-radius: 5px;
  }
  .ant-checkbox-wrapper:hover {
    background: #eeeeee;
  }
`;

export const JobLocationFilterRoot = styled("div")<TokenProps>`
  flex: 1;
  position: relative;

  input,
  .ant-select-selection-placeholder {
    font-size: 15px !important;
  }

  .ant-select {
    margin-bottom: 0;
    height: 3.625rem !important;
  }

  .ant-select-selector {
    border-radius: 5px;
    border: 1px solid ${(props) => props.$token?.colorBorder};
    color: ${(props) => props.$token?.colorTextSecondary};
    cursor: pointer;
    height: 3.625rem !important;
    text-transform: capitalize;
  }

  .ant-select-auto-complete {
    width: 100%;
    color: ${(props) => props.$token?.colorTextSecondary};
  }

  .ant-select:not(.ant-select-multiple)
    .ant-select-selector
    > .ant-select-selection-wrap
    > .ant-select-selection-search
    > input,
  .ant-select-selection-placeholder {
    padding-left: 2.25rem !important;
  }

  .ant-select-clear {
    margin: 0 !important;
    opacity: 1 !important;
    top: calc(50% - 12px) !important;
    width: 24px;
  }

  @media screen and (max-width: 992px) {
    .ant-select,
    .ant-select-selector {
      height: 2.5rem !important;
    }

    .ant-select:not(.ant-select-multiple) .ant-select-selector:has(.ant-select-selection-search) {
      padding: 11px !important;
    }
  }
`;

export const ClearIcon = styled(CloseCircle)`
  color: ${BRAND_BOOK_COLORS.BLACK};
  opacity: 0.25;
  width: 24px;
  &:hover {
    opacity: 0.5;
  }
`;

export const ClearLink = styled(Typography)`
  color: #757575;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.4px;
  line-height: 20px;
  margin-left: auto;
  margin-top: -6px;
  text-decoration: underline;
  text-decoration-line: underline;
  @media screen and (max-width: 992px) {
    font-size: 12px;
    letter-spacing: 0.3px;
  }
`;

export const LocationIcon = styled(MapPin2)<TokenProps>`
  color: ${(props) => props.$token?.colorPrimary || "#000"};
  height: 1.5rem;
  margin-left: 0.75rem;
  margin-top: 1.05rem;
  position: absolute;
  z-index: 1;
  @media screen and (max-width: 992px) {
    margin-top: 0.5rem;
  }
`;

export const SearchButton = styled(Button).attrs({
  type: "primary",
})<TokenProps>`
  color: ${BRAND_BOOK_COLORS.WHITE};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.$token?.colorPrimary};
  height: 3.625rem;
  padding: 8px;
  width: 106px;
  font-size: 15px;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  @media screen and (max-width: 992px) {
    width: 100%;
    height: 1.75rem;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.465px;
  }
`;

export const ShowMoreButton = styled(Button).attrs({
  type: "primary",
})`
  margin-top: 16px;
  margin-right: 1rem;
  padding: 2px 15px;
  height: 28px;
  font-size: 12px;
  span {
    letter-spacing: 0.3px;
  }
`;
